import dayjs from 'dayjs';

export type Nullable<T> = {
  [K in keyof T]: T[K] | null;
};

export const nullsToUndefined = <T>(obj: T): T => {
  if (obj === null) {
    return undefined as unknown as T;
  }
  if (Array.isArray(obj)) {
    return obj.map(nullsToUndefined) as unknown as T;
  }
  if (obj instanceof Map || obj instanceof Set || obj instanceof dayjs) {
    return obj;
  }
  if (typeof obj === 'object') {
    const result: Record<string, unknown> = {};
    for (const key in obj) {
      if (Object.hasOwn(obj, key)) {
        result[key] = nullsToUndefined((obj as T)[key]);
      }
    }
    return result as T;
  }

  return obj;
};
